import { AsyncThunk, UnknownAction, createAction } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch as useReduxDispatch, useSelector as useReduxSelector } from 'react-redux';
import { AppDispatch, RootState } from './index';

export const useDispatch: () => AppDispatch = useReduxDispatch;
export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

type GenericAsyncThunk = AsyncThunk<unknown, unknown, any>;
export type PendingAction = ReturnType<GenericAsyncThunk['pending']>;
export type FulfilledAction = ReturnType<GenericAsyncThunk['fulfilled']>;
export type RejectedAction = ReturnType<GenericAsyncThunk['rejected']>;

export const isPendingAction = (action: UnknownAction): action is PendingAction => {
  return typeof action.type === 'string' && action.type.endsWith('/pending');
};

export const isFulfilledAction = (action: UnknownAction): action is PendingAction => {
  return typeof action.type === 'string' && action.type.endsWith('/fulfilled');
};

export const isRejectedAction = (action: UnknownAction): action is PendingAction => {
  return typeof action.type === 'string' && action.type.endsWith('/rejected');
};
